import { getRouterContext, registerHook } from 'hybridly'
import { t } from '@/application/i18n'

const pageTitleOverride = ref<string | null>(null)
const pageTitleLink = ref<string | null>(null)
let pendingOverride = false

export function usePageTitle() {
	const defaultTitle = ref<string>('')

	function updateDefaultTitle() {
		const component = getRouterContext()?.view.component || ''
		defaultTitle.value = t(`app.${component.replace('/', '_')}.title`)
	}

	updateDefaultTitle()

	// Mark that we're expecting a new override from the incoming page
	registerHook('start', () => {
		pendingOverride = true
	})

	// After navigation, if no override was set, clear any existing override
	registerHook('success', () => {
		if (pendingOverride) {
			pageTitleOverride.value = null
			pageTitleLink.value = null
		}
		pendingOverride = false
		updateDefaultTitle()
	})

	const pageTitle = computed(() => pageTitleOverride.value ?? defaultTitle.value)

	useHead({ title: pageTitle })

	return {
		pageTitle: readonly(pageTitle),
		pageTitleLink: readonly(pageTitleLink),
	}
}

export function setPageTitle(title: string, link?: string) {
	pendingOverride = false
	pageTitleOverride.value = title
	pageTitleLink.value = link ?? null
}
